import React, { Component, Fragment } from 'react';
import {
  arrayOf, bool, func, node, number, oneOfType, string
} from 'prop-types';
import classNames from 'classnames';
import Content from './Content';
import Footer from './Footer';
import './Card.styles.scss';

/** THD Card component. */

class Card extends Component {

  static Content = Content;

  static Footer = Footer;

  state = {
    triggeredOverlay: null,
    scrollToBottom: false
  };

  componentDidMount() {
    const { getOnClick } = this.props;

    window.addEventListener('hashchange', this.checkOverlayHash);
    if (getOnClick) {
      getOnClick(this.handleFooterClick);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.checkOverlayHash);
  }

  checkOverlayHash = (event) => {
    const { oldURL = '' } = event;
    if (oldURL.indexOf('#overlay') > -1) {
      this.setState({ triggeredOverlay: null });
      document.body.classList.toggle('body--noscroll', false);
    }
  };

  desktopItems = (allItems) => {
    return allItems.filter((child) => !!child && [Footer, Content].indexOf(child.type) === -1);
  };

  handleFooterClick = (clickedElement, triggeredOverlay, scrollToBottom) => {
    this.setState({
      triggeredOverlay,
      scrollToBottom
    }, Content.setOverlayHash);
  };

  mobileItems = (allItems) => {
    const { triggeredOverlay, scrollToBottom } = this.state;

    return allItems.filter((child) => !!child && [Footer, Content].indexOf(child.type) > -1)
      .map((eachItem) => {
        if (eachItem.type === Content) {
          return {
            ...eachItem,
            props: {
              ...eachItem.props,
              triggered: triggeredOverlay,
              scrollToBottom
            }
          };
        }

        if (eachItem.type === Footer) {
          return {
            ...eachItem,
            props: {
              ...eachItem.props,
              onTriggerClick: this.handleFooterClick
            }
          };
        }

        return eachItem;
      });
  };

  render() {
    const {
      children,
      className,
      noHide,
    } = this.props;

    const cardClasses = classNames(
      'content-card',
      className,
      {
        'content-card--responsive': !noHide,
      }
    );

    const wrapperClasses = classNames(
      'content-card__wrapper',
      {
        'content-card__wrapper--mobile': noHide,
        'content-card__wrapper--responsive': !noHide,
      }
    );

    const elements = Array.isArray(children) ? children : [children];

    return (
      <>
        <div className="desktop-items">
          { this.desktopItems(elements) }
        </div>
        <div className={wrapperClasses}>
          <div className={cardClasses}>
            { this.mobileItems(elements) }
          </div>
        </div>
      </>

    );
  }
}

Card.displayName = 'Card';

Card.propTypes = {
  /** Card content */
  children: oneOfType([
    node,
    arrayOf(node)
  ]).isRequired,
  /** Additional classes */
  className: string,
  /** Ignore card breakpoint */
  noHide: bool,
  /** callback of triggering content onclick */
  getOnClick: func
};

Card.defaultProps = {
  className: null,
  noHide: false,
  getOnClick: null
};

export default Card;
